<template>
  <svg
    :style="svgStyle"
    :viewBox="`0 0 ${width} ${height}`"
    :preserveAspectRatio="preserveAspectRatio"
  >
    <rect
      :style="`fill: url(#${idGradient})`"
      :clip-path="`url(#${idClip})`"
      x="0"
      y="0"
      :width="width"
      :height="height"
    />

    <defs>
      <clipPath :id="idClip">
        <slot>
          <rect
            x="0"
            y="0"
            rx="5"
            ry="5"
            :width="width"
            :height="height"
          />
        </slot>
      </clipPath>

      <linearGradient :id="idGradient">
        <stop
          offset="0%"
          :stop-color="edgeColor"
        >
          <animate
            v-if="shouldAnimate"
            attributeName="offset"
            values="-2; 1"
            :dur="`${speed}s`"
            repeatCount="indefinite"
          />
        </stop>
        <stop
          offset="50%"
          :stop-color="middleColor"
        >
          <animate
            v-if="shouldAnimate"
            attributeName="offset"
            values="-1.5; 1.5"
            :dur="`${speed}s`"
            repeatCount="indefinite"
          />
        </stop>
        <stop
          offset="100%"
          :stop-color="edgeColor"
        >
          <animate
            v-if="shouldAnimate"
            attributeName="offset"
            values="-1; 2"
            :dur="`${speed}s`"
            repeatCount="indefinite"
          />
        </stop>
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'LoadingSkeletonBase',
  props: {
    svgStyle: {
      type: Object,
      default: () => {},
    },
    preserveAspectRatio: {
      type: String,
      default: 'xMidYMin meet',
    },
    width: {
      validator: (value) => typeof value === 'number'
            || (typeof value === 'string' && (value.endsWith('%') || value === 'auto')),
      default: 400,
    },
    height: {
      type: Number,
      default: 130,
    },
    speed: {
      type: Number,
      default: 2,
    },
    primaryColor: {
      type: String,
      default: null,
    },
    secondaryColor: {
      type: String,
      default: null,
    },
    uniqueKey: {
      type: String,
      default: null,
    },
    shouldAnimate: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      idClip: this.uniqueKey
        ? `${this.uniqueKey}-idClip`
        : this.uid(),
      idGradient: this.uniqueKey
        ? `${this.uniqueKey}-idGradient`
        : this.uid(),
    };
  },
  computed: {
    edgeColor() {
      return this.primaryColor
        ? this.primaryColor
        : `rgba(${this.selectedTheme?.border.color.rgb}, 0.5)`;
    },
    middleColor() {
      return this.secondaryColor
        ? this.secondaryColor
        : `rgba(${this.selectedTheme?.border.color.rgb}, 0.1)`;
    },
  },
  methods: {
    uid() {
      return Math.random().toString(36).substring(2);
    },
  },
};
</script>
